import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer mb-3" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-heading">黑料导航</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              最全娱乐黑料聚合平台，精准聚合全网最热娱乐黑料、明星丑闻、网红爆料内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">热门分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">更多分类</h4>
            <ul className="space-y-2">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">关于本站</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">免责声明</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 黑料导航 - 娱乐黑料聚合平台. 本站内容来源于网络，仅供娱乐参考。
          </p>
          <p className="text-xs text-foreground-500">
            内容持续更新中 · 最新黑料一网打尽
          </p>
        </div>
      </div>
    </footer>
  );
}